import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'index',
		component: index,
		meta: {
			title: ''
		},
	}, 
	// {
	// 	path: '/login',
	// 	name: 'login',
	// 	component: () => import( /* webpackChunkName: "login" */ '../views/login/login.vue'),
	// 	meta: {
	// 		title: ''
	// 	},
	// },

]

const router = new VueRouter({
	routes
})

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

router.beforeEach((to, from, next) => {
	/* 路由发生变化修改页面title */
	if (to.meta.title) {
		document.title = to.meta.title
	}
	next()
})

export default router